import styled from "styled-components";

const PageContent= styled.div`
    position: relative;
    margin-left:124px;
    min-height: 100vh;
  
`

export default PageContent;